import React, { useEffect } from 'react';
import axios from 'axios';
import config from '../../config';
import './Flash.css';

export default function NewBulletin() {
  const [activePost, setActivePost] = React.useState([]);
  const [loaded, setLoaded] = React.useState(false);
  const [dispMsg, setDispMsg] = React.useState("Loading...");

  useEffect(() => {
    fetchActiveInfo();
  }, []);

      const generateDate = async () => {
        const current_datetime = new Date();
        const date_year = (current_datetime.getFullYear()).toString();
        var date_month = (current_datetime.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (current_datetime.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var date_hours = (current_datetime.getHours().toString());
        var hours_value="";
        date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
        var date_minutes = (current_datetime.getMinutes().toString());
        var minutes_value="";
        date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
        var todayDate="";
        const tDate = todayDate.concat(date_year,"-",month_value,"-", date_value);
        //setUserId(accountNo);
        return tDate;
        //console.log("acc : ", accountNo);
    }    

 const fetchActiveInfo =async(filterValue)=>{
        try{
            setLoaded(false);
           //const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const startDate=await generateDate();
            const clientID="DACA";
            const searchOption="ActiveFlashNews";
            var searchFilter="Active";
        await axios.get(`${config.api.invokeURL}/website/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}&searchFilter=${searchFilter}`,{
            headers: {
             // Authorization: idToken,
              'x-api-key': config.api.key
            }}, 
        ).then((response)=>{
            //console.log(response);
            setActivePost(response.data);
           // setGalleryImages(response.data);
           //enqueueSnackbar(response.data.length + " - " + searchFilter + " Messages available", {variant:'success'}); 
            setLoaded(true);
            //setDispMsg(response.data.length + " - Images are found in your Gallery");
        }).catch((error)=>{
            //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
            setLoaded(true);
        })
    }catch(error){
		//console.log(error);
        //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
        //setDispMsg(error.message);
    }
    }

  return (
    <div className='container-fluid px-0'>
    <div className='news-sec-border '  style={{verticalAlign:"center"}}>
      <div className='d-flex' >
    <div className='news-sec'>
         <spam className='news-title-design p-5 '>News...</spam> 
    </div>
    <div className="news-marquee-wrap">
      <div className="enable-animation" style={{width: '100%'}}>
      <div className="marquee marquee--hover-pause" style={{verticalAlign:"middle", alignContent:"center", width: '100%' }}>
        <ul className="marquee__content ">
          {activePost.map((item,index)=>
          <li key={index} style={{listStyleType:"none", backgroundColor:item.flashNews.bcolor, color:item.flashNews.fcolor}}><b><i className="fas fa-bullhorn me-2 "></i>{item.flashNews.message}</b></li>)}
        </ul>
      
        <ul aria-hidden="true" className="marquee__content">
        {activePost.map((item,index)=>
          <li key={index} style={{listStyleType:"none", backgroundColor:item.flashNews.bcolor, color:item.flashNews.fcolor}}><b><i className="fas fa-bullhorn me-2 "></i>{item.flashNews.message}</b></li>)}
          </ul>
      </div>
      </div>
  </div>
    {/*<marquee  style={{fontSize:"20px", paddingTop:"2%"}}>Hearty Welcome</marquee>*/}
    {/*} <marquee style={{ fontSize: "20px", paddingTop: "2%" }}>
                    {activePost.map((message, index) => (
                        <span key={index} className="message">
                            {message.flashNews.message}
                        </span>
                    ))}
                </marquee>*/}
      </div>
     </div>
    </div>
  )
}
